import React, { Component } from 'react'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import SelectList from 'components/common/SelectList'
import { fetchSiteList } from 'reducers/logbookForm/reducer'
import { setSiteContext } from 'reducers/profile/reducer'
import Psfs from 'lib/psfs/Psfs'
import messages from '../translate'

class SiteFilter extends Component {
  onSiteChange = value => {
    const { activeSite } = this.props

    if (value && activeSite !== value.index) {
      this.props.setSiteContext({ site: value.index })
    }
  }

  componentDidMount() {
    const psfs = new Psfs()
    psfs.addFilter('active', 1)
    psfs.addFilter('visibleInUi', 1)
    this.props.fetchSiteList({ psfs })
  }

  render() {
    const {
      siteList,
      activeSite,
      intl: { formatMessage },
    } = this.props

    return (
      <SelectList
        variant="outlined"
        name="site"
        label={formatMessage(messages.siteList)}
        onChange={this.onSiteChange}
        list={siteList}
        value={activeSite}
        map={{
          index: 'id',
          text: 'name',
        }}
      />
    )
  }
}

export default connect(
  state => ({
    siteList: state.getIn(['logbookForm', 'siteList']),
    activeSite: state.getIn(['profile', 'siteId']),
  }),
  {
    fetchSiteList,
    setSiteContext,
  },
)(injectIntl(SiteFilter))
